import { element as elementNS } from '../../cls';
import './text.less';

export var element = elementNS('text');